import { GraphQLClient } from 'graphql-request';
import { DOM } from '@app/utils';
import { LANGUAGES } from '@app/i18n/data/languages';
import { LABELS } from '@app/config';
import getOrSetStockXSessionId from '@app/user/utils/getOrSetStockXSessionId';
import type { clientOptions } from '../types';

/**
 * We can reuse the same client in the browser
 */
let client;

/**
 * Token
 */
const getTokenFromCookie = () => DOM.getCookie('token');

/**
 * Language
 */
const getLanguageFromCookie = () => {
  const langCode = DOM.getCookie<string>('language_code') || 'en';
  const { url: langLocale } = LANGUAGES[langCode];
  const [language, locale] = langLocale.split('-');
  return `${language}-${locale.toUpperCase()}`;
};

/**
 * Device ID
 */
const getDeviceIdFromCookie = () => DOM.getCookie('stockx_device_id');

/**
 * session ID
 */
const getSessionIdFromCookie = () => getOrSetStockXSessionId();

/**
 * Country Code
 */
const getCountryCodeFromCookie = () =>
  DOM.getCookie('stockx_selected_region') || DOM.getCookie('stockx_ip_region');

/**
 * @param options
 */
const clientBrowser = (options: clientOptions): GraphQLClient => {
  if (client) {
    return client;
  }

  const {
    token = getTokenFromCookie(),
    language = getLanguageFromCookie(),
    deviceId = getDeviceIdFromCookie(),
    sessionId = getSessionIdFromCookie(),
    countryCode = getCountryCodeFromCookie(),
  } = options;

  const headers: Dict = {
    'apollographql-client-name': LABELS.APP_HUMAN_NAME,
    'apollographql-client-version': LABELS.APP_HUMAN_VERSION,
    'App-Platform': LABELS.APP_HUMAN_NAME,
    'App-Version': LABELS.APP_HUMAN_VERSION,
    ...(language ? { 'accept-language': language } : {}),
    ...(token ? { authorization: `Bearer ${token}` } : {}),
    ...(deviceId ? { 'x-stockx-device-id': deviceId } : {}),
    ...(sessionId ? { 'x-stockx-session-id': sessionId } : {}),
    ...(countryCode
      ? {
          'selected-country': countryCode,
        }
      : {}),
  };

  client = new GraphQLClient('/api/p/e', { headers });

  return client;
};

export default clientBrowser;
